/*:: type Dictionary = { [string]: string };*/

/*:: type LocaleDictionary = { locale: string, content: Dictionary, isDefault?: boolean }*/

/*:: type LocaleDictionaryList = Array<LocaleDictionary>;*/

/*:: type FieldName = string;*/

/*:: type LocalizedFieldName = string;*/

/*:: type FieldMapping = [FieldName, LocalizedFieldName, isOptional];*/

/* eslint no-underscore-dangle: 0 arrow-body-style: 0 */
class ModelLocalizer {
  constructor({
    /*: { locales: Array<string>, fieldMapping: Array<FieldMapping> }*/

    locales,
    fieldMapping
  }) {
    this.locales = locales;
    this.fieldMapping = fieldMapping;
  }

  setLocalizations(model
  /*: Object*/
  , dictionaries
  /*: LocaleDictionaryList*/
  )
  /*: Object*/
  {
    // Prepare localizable fields
    this.fieldMapping.forEach(([, localizedField]) => {
      // eslint-disable-next-line no-param-reassign
      model[localizedField] = {};
    }); // Assign each localized value from the dictionaries

    dictionaries.sort((a, b) => {
      // ensure the translations are in the same order as this.locales
      const ai = this.locales.indexOf(a.locale);
      const bi = this.locales.indexOf(b.locale);
      return ai - bi;
    }).forEach(({
      locale,
      content
    }) => {
      this.fieldMapping.forEach(([field, localizedField]) => {
        // eslint-disable-next-line no-param-reassign
        model[localizedField][locale] = content[field];
      });
    });
    if (!this.hasNonEmptyDictionaries(dictionaries)) this.createDefaultDictionary(model);
    const defaultDictionary = this.findFirstValidDictionary(dictionaries) || this.findFirstNonEmptyDictionary(dictionaries); // eslint-disable-next-line no-param-reassign

    model._localization = {
      locales: this.locales,
      modelDefaultLocale: defaultDictionary && defaultDictionary.locale
    };
    return model;
  }

  getLocalizations(model
  /*: Object*/
  )
  /*: LocaleDictionaryList*/
  {
    const dictionaries = this.locales.map(locale => {
      const content = this.fieldMapping.reduce((acc, [field, localizedField]) => {
        const dictionary = model[localizedField];
        if (dictionary) acc[field] = dictionary[locale];
        return acc;
      }, {});
      return {
        locale,
        content
      };
    });
    const defaultDictionary = this.findFirstNonEmptyDictionary(dictionaries);
    if (defaultDictionary) defaultDictionary.isDefault = true;
    return dictionaries;
  }

  applyDefaultLocalizations(model
  /*: Object*/
  )
  /*: Object*/
  {
    const dictionaries = this.getLocalizations(model);
    const defaultDictionary = this.findFirstValidDictionary(dictionaries);
    if (!defaultDictionary) return model;
    this.fieldMapping.forEach(([field]) => {
      // eslint-disable-next-line no-param-reassign
      model[field] = defaultDictionary.content[field];
    });
    return model;
  }

  findDefaultDictionary(dictionaries
  /*: LocaleDictionaryList*/
  )
  /*: ?LocaleDictionary*/
  {
    const defaultLocale = this.locales[0];
    return dictionaries.find(d => d.isDefault) || dictionaries.find(d => d.locale === defaultLocale);
  }

  findFirstNonEmptyDictionary(dictionaries
  /*: LocaleDictionaryList*/
  )
  /*: ?LocaleDictionary*/
  {
    return dictionaries.find(dictionary => {
      return !this.isEmptyDictionary(dictionary);
    });
  }

  isEmptyDictionary(dictionary
  /*: LocaleDictionary*/
  ) {
    const result = !this.fieldMapping.some(([field]) => !!dictionary.content[field]);
    return result;
  }

  hasNonEmptyDictionaries(dictionaries
  /*: LocaleDictionaryList*/
  ) {
    if (!dictionaries.length) return false;
    return dictionaries.some(d => !this.isEmptyDictionary(d));
  }

  findFirstValidDictionary(dictionaries
  /*: LocaleDictionaryList*/
  )
  /*: ?LocaleDictionary*/
  {
    return dictionaries.find(dictionary => {
      return this.isValidDictionary(dictionary);
    });
  }

  isValidDictionary(dictionary
  /*: LocaleDictionary*/
  ) {
    const requiredFields = this.fieldMapping.filter(([,, isOptional]) => !isOptional);
    const result = requiredFields.every(([field]) => {
      return !!dictionary.content[field];
    });
    return result;
  }

  hasValidDictionaries(dictionaries
  /*: LocaleDictionaryList*/
  ) {
    if (!dictionaries.length) return false;
    return dictionaries.some(d => this.isValidDictionary(d));
  }

  createDefaultDictionary(model
  /*: Object*/
  ) {
    const defaultLocale = this.locales[0];
    this.fieldMapping.forEach(([field, localizedField]) => {
      // eslint-disable-next-line no-param-reassign
      model[localizedField][defaultLocale] = model[field];
    });
  }

}

module.exports = ModelLocalizer;